import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/app/modules/auth/shared/auth.service';
import { TranslationService } from 'src/app/modules/core/services/translation.service';

@Component({
  selector: 'app-language-toolbar',
  templateUrl: './language-toolbar.component.html',
  styleUrls: ['./language-toolbar.component.scss']
})
export class LanguageToolbarComponent implements OnInit {
  @Input() isSidebar: boolean = false;
  user: boolean = false;
  languages: any;
  currentLanguage: any;
  hovered = false;
  screenWidth = window.innerWidth;
  filters = ['en', 'fr'];

  constructor(private translationService: TranslationService, private authService: AuthService) {
  }

  ngOnInit(): void {
    this.currentLanguage = this.translationService.getSelectedLanguage();
    this.setCurrentLanguage(this.currentLanguage);
    this.authService.getCurrentUser().subscribe((currentUser) => {
      currentUser ? this.user = true : this.user = false;
      this.languages = [...this.translationService.getLanguages()];
    });
  }

  editLangs(): any {
    this.currentLanguage = this.translationService.getSelectedLanguage();
    this.languages = [...this.translationService.getLanguages()];
    const index = this.languages.indexOf(this.currentLanguage);
    if (index > -1) {
      this.languages.splice(index, 1);
    }
  }

  setCurrentLanguage(lang: string, isChangeLangBtn?: boolean): any {
    this.translationService.setLanguage(lang, isChangeLangBtn);
    this.editLangs()
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    this.screenWidth = window.innerWidth;
  }
}
